import { DiscountsList } from 'components/discounts/DiscountsList/DiscountsList'
import { useParams } from 'react-router-dom'

export const SellerDiscounts: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <DiscountsList sellerId={id as string} />
}
